import React, { useReducer } from 'react';
//import  uuid  from 'uuid';
//import { v4 as uuidv4 } from 'uuid';
import axiosClient from '../../config/axios';
import projectContext from './projectContext';
import projectReducer from './projectReducer';
import { 
        PROJECT_FORM,
        GET_PROJECT,
        ADD_PROJECT,
        VALIDATE_FORM,
        ACTUAL_PROJECT,
        DELETE_PROJECT,
        ERROR_PROJECT
    } from '../../types'

const ProjectState = props => {
    
     const initialState = {
        projects : [],
        form: false,
        errorForm: false,
        project: null,
        message: null
    }

    const [ state, dispatch ] =  useReducer(projectReducer, initialState);

    const showForm = () => {
        dispatch({
            type: PROJECT_FORM
        })
    }

    // Returns an shows the projects
    const getProjects = async () => {
        try {
            const response = await axiosClient.get('/api/projects');
            dispatch({
                type: GET_PROJECT,
                payload: response.data.projects
            })
        } catch (error) {
            const alert = {
                msg: 'Error while getting projects',
                category: 'alerta-error'
            }
            dispatch({
                type: ERROR_PROJECT,
                payload: alert
            });
        }
    }

    // Add a project to the form
    const addProject = async project => {

        try {
            const response = await axiosClient.post('/api/projects', project);
            console.log(response.data.project);
            
            // Add project to the state
            dispatch({
                type: ADD_PROJECT,
                payload: response.data.project
            });
        } catch (error) {
            const alert = {
                msg: 'Error while creating project',
                category: 'alerta-error'
            }
            dispatch({
                type: ERROR_PROJECT,
                payload: alert
            });
        }
    }

    // Validates for errors in project creation
    const showError = () => {
        dispatch({
            type: VALIDATE_FORM
        });
    }

    // Select the clicked project
    const actualProject = projectID => {
        dispatch({
            type: ACTUAL_PROJECT,
            payload: projectID
        });
    }

    // Delete a project
    const deleteProject = async projectID => {
        try {
            await axiosClient.delete(`/api/projects/${ projectID }`);
            dispatch({
                type: DELETE_PROJECT,
                payload: projectID
            });
        } catch (error) {
            const alert = {
                msg: 'Error while deleting project',
                category: 'alerta-error'
            }
            dispatch({
                type: ERROR_PROJECT,
                payload: alert
            });
        }
    }

    return (
        <projectContext.Provider
            value={{
                projects: state.projects,
                form: state.form,
                errorForm: state.errorForm,
                project: state.project,
                message: state.message,
                showForm,
                getProjects,
                addProject,
                showError,
                actualProject,
                deleteProject
            }}
        >
            { props.children }
        </projectContext.Provider>
    )
}

export default ProjectState;